import React from 'react'
import Headers from '../headers/Headers'

const ReadMoreSol = () => {
  return (
    <>
    <Headers/>
      <div>
        <h2>Read More</h2>
      </div>
    </>
  )
}

export default ReadMoreSol
